import { BodyText, Span } from '@gaiads/telia-react-component-library';
import React from 'react';
import { LocaleResponse } from '@cdaas/api-clients/dist/product-service-openapi';

interface LanguageListProps {
  languages?: number[];
  locales: LocaleResponse[];
}

const LanguageList = ({ languages, locales }: LanguageListProps) => {
  if (!languages) {
    return null;
  }

  const allTrimmedLanguages = locales.map(locale => {
    const { id, language_tag } = locale;
    const match = languages.find(productLanguageId => productLanguageId === id);
    // Get first two letters from locale string. e.g. "en-US" => "en"
    const trimmedTagName = language_tag ? language_tag.split('-')[0] : '';
    return {
      name: trimmedTagName.toUpperCase(),
      enabled: !!match,
    };
  });

  const allLanguagesCount = allTrimmedLanguages.length;
  const sortedLanguages = allTrimmedLanguages.sort((a, b) => a.name.localeCompare(b.name));

  return (
    <BodyText>
      {sortedLanguages.map((language, index) => (
        <Span key={language.name} className={language.enabled ? '' : 'telia-react-table_row__disabled'}>
          {language.name}
          {index + 1 < allLanguagesCount && ', '}
        </Span>
      ))}
    </BodyText>
  );
};

export default LanguageList;
